import React from "react";
import { ChildrenContainer, ContentContainer, MainContainer } from "./styles";
import TopBar from "./components/TopBar";
import Menu from "./components/Menu";
import { EnterpriseProps } from "./types";
import { EnterpriseProvider } from "./hooks/useEnterprise";

const Enterprise: React.FC<EnterpriseProps> = ({ children }): JSX.Element => {
  return (
    <EnterpriseProvider>
      <MainContainer>
        <TopBar />
        <ContentContainer>
          <Menu />
          <ChildrenContainer>{children}</ChildrenContainer>
        </ContentContainer>
      </MainContainer>
    </EnterpriseProvider>
  );
};

export default Enterprise;
